<template>
  <div
    class="header-custom"
    :style="theme.header.image == '' ? headerColor : headerImage"
  >
    <img
      :src="
        `${
          restaurant.logo
            ? 'htttp://localhost:3333/logos/' + restaurant.logo
            : 'htttp://localhost:3333/logos/logo.png'
        }`
      "
      alt=""
      :class="`logo-custom ${getClassPostion(theme.logo.position)}`"
    />
  </div>
  <!-- <div class="cc">
    <div class="f">
      HELLO
      <img src="/logos/{{restaurant.logo}}" alt="" class="logo" />
    </div>
  </div> -->
</template>

<script>
export default {
  props: [
    "restaurant",
    "smaler",
    "changeName",
    "currentLang",
    "newItem",
    "theme"
  ],
  computed: {
    headerColor: function() {
      console.log(this.theme);
      return {
        "background-color": this.theme.header.color
      };
    },
    headerImage: function() {
      return {
        "background-image": `url(${this.theme.header.image})`
      };
    }
  },
  data() {
    return {
      // apiPath1: apiPath1,
      name: "name of the menu"
    };
  },
  methods: {
    getClassPostion(position) {
      console.log();
      if (position == "right") {
        return "right-custom";
      } else if (position == "left") {
        return "left-custom";
      }
      return "";
    }
  },
  watch: {
    name(newVal) {
      this.changeName(newVal);
    }
  }
};
</script>
<style>
@import url("../styles/customTheme/header.css");
</style>
